module.exports = __webpack_public_path__ + "static/pooh-v2-01-c15a55cb1f3d8d5ca7ffad83ba102ce8.jpg";